export default function getDataLocalStorage(storagename){
    let currentLocalStorage = localStorage.getItem(storagename);
    let newLocalStorage = currentLocalStorage ? JSON.parse(currentLocalStorage) : {};
    localStorage.setItem(storagename, JSON.stringify(newLocalStorage));
    return newLocalStorage;
}